import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule } from "@angular/forms";

import { STORAGE_PREFIX } from "./global_services/storage.service";

import { BuildingBlocksModule } from "@building-blocks/building-blocks.module";
import { GlobalServicesModule } from "./global_services/global-services.module";
import { NotfoundPageModule } from "./pages/notfound-page/notfound-page.module";
import { PagesModule } from "./pages/pages.module";

/* COMPONENTS */
import { AppComponent } from "./app.component";
import { EcertBaseBlockComponent } from "@building-blocks/ecertnl-base-block/ecertnl-base-block.component";
import { NotfoundPageComponent } from "./pages/notfound-page/notfound-page/notfound-page.component";

/* SERVICES */
// import { DocumentLoaderService } from "./services/document_loader.service";
import { ApplicationUtilsService, EcertMeldingService, DocumentLoaderService } from "@util-services";
import { CheckCertificateComponent } from "./pages/check-certificate/check-certificate.component";
import { HttpWrapperService} from "@util-services";
import { DragulaModule } from 'ng2-dragula';

export const AppRoutes: Routes = [
  { path: "**", component: NotfoundPageComponent, pathMatch: "full" },
];

// declarations: [AppComponent, EcertBaseBlockComponent],

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(AppRoutes),
    DragulaModule.forRoot(),
    FormsModule,
    BuildingBlocksModule,
    GlobalServicesModule,
    NotfoundPageModule,
    PagesModule,
  ],
  providers: [
    ApplicationUtilsService,
    DocumentLoaderService,
    EcertMeldingService,
    HttpWrapperService,
    { provide: STORAGE_PREFIX, useValue: "download-ephyto_" },
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ApplicationUtilsService) => () => config.load(),
      deps: [ApplicationUtilsService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
